module.exports = __webpack_public_path__ + "img/preview-15.a483217d.png";